import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import MobileHeaderActions from '../headers/modules/MobileHeaderActions';
import Link from 'next/link';

const HeaderMobileProduct = () => {
    const [isSticky, setIsSticky] = useState(false);
    const headerRef = useRef(null);
    const stickyRef = useRef(null);

    const cartItems = useSelector(({ ecomerce }) => ecomerce.cartItems || []);
    const [pulseCartCount, setPulseCartCount] = useState(false);
    const prevCartTotalRef = useRef(0);
    const isInitialMountRef = useRef(true);
    const mountedRef = useRef(false);

    useEffect(() => {
        const updateCartCount = () => {
            try {
                const cart = JSON.parse(localStorage.getItem('cartItems') || '[]');
                const newCartTotal = cart.reduce((total, item) => total + (item.quantity || 1), 0);
                triggerPulseIfAdded('cart', newCartTotal);
            } catch {
                const reduxCartTotal = cartItems.reduce((total, item) => total + (item.quantity || 1), 0);
                triggerPulseIfAdded('cart', reduxCartTotal);
            }
        };

        const handleStorage = (e) => {
            if (e.key === 'cartItems') {
                updateCartCount();
            }
        };

        window.addEventListener('storage', handleStorage);
        return () => window.removeEventListener('storage', handleStorage);
    }, [cartItems]);

    const triggerPulseIfAdded = useCallback((type, currentTotal) => {
        const prevTotal = prevCartTotalRef.current;
        if (mountedRef.current && !isInitialMountRef.current && currentTotal > prevTotal) {
            setPulseCartCount(true);
            setTimeout(() => setPulseCartCount(false), 500);
        }
        prevCartTotalRef.current = currentTotal;
    }, []);

    useEffect(() => {
        mountedRef.current = true;
        return () => { mountedRef.current = false; };
    }, []);

    useEffect(() => {
        if (isInitialMountRef.current) {
            isInitialMountRef.current = false;
            return;
        }
        try {
            const cart = JSON.parse(localStorage.getItem('cartItems') || '[]');
            const newCartTotal = cart.reduce((total, item) => total + (item.quantity || 1), 0);
            triggerPulseIfAdded('cart', newCartTotal);
        } catch {
            const reduxCartTotal = cartItems.reduce((total, item) => total + (item.quantity || 1), 0);
            triggerPulseIfAdded('cart', reduxCartTotal);
        }
    }, [cartItems, triggerPulseIfAdded]);

    useEffect(() => {
        if (process.browser) {
            const handleScroll = () => {
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                setIsSticky(scrollTop >= 300);
            };

            window.addEventListener('scroll', handleScroll, { passive: true });
            return () => window.removeEventListener('scroll', handleScroll);
        }
    }, []);

    return (
        <>
            <style>{`
                #headerMobileSticky {
                    position: relative !important;
                    z-index: 1003 !important;
                    background: white !important;
                }
                
                #headerMobileSticky.header--sticky {
                    position: fixed !important;
                    top: 0 !important;
                    left: 0 !important;
                    right: 0 !important;
                    width: 100vw !important;
                    background: rgba(255,255,255,0.98) !important;
                    backdrop-filter: blur(20px) !important;
                    box-shadow: 0 4px 20px rgba(0,0,0,0.15) !important;
                    transform: translateY(0);
                    transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) !important;
                }
                
                body, html {
                    padding-top: 0 !important;
                    margin-top: 0 !important;
                }

                .header--mobile-product .navigation--mobile {
                    transition: all 0.3s ease !important;
                }

                .mobile-pulse-active .header__extra span {
                    animation: cartPulse 0.5s ease-in-out !important;
                }
                @keyframes cartPulse {
                    0% { transform: scale(1); }
                    50% { transform: scale(1.5); }
                    100% { transform: scale(1); }
                }
            `}</style>
            
            <header 
                ref={headerRef}
                className="header header--mobile header--mobile-product"
                id="headerMobileSticky"
                data-sticky="true">
                <div className="navigation--mobile">
                    <div className="navigation__left">
                        <Link href="/" className="ps-logo">
                            <img
                                src="/static/img/logo_light.png"
                                alt="rawento"
                                suppressHydrationWarning
                            />
                        </Link>
                    </div>
                    <div className={pulseCartCount ? 'mobile-pulse-active' : ''}>
                        <MobileHeaderActions />
                    </div>
                </div>
            </header>
            
            {isSticky && (
                <header 
                    ref={stickyRef}
                    className="header header--mobile header--mobile-product header--sticky"
                    id="headerMobileStickyOverlay"
                    data-sticky="true"
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        width: '100vw',
                        zIndex: 1004,
                        background: 'rgba(255,255,255,0.98)',
                        backdropFilter: 'blur(20px)',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
                    }}>
                    <div className="navigation--mobile">
                        <div className="navigation__left">
                            <Link href="/" className="ps-logo">
                                <img
                                    src="/static/img/logo_light.png"
                                    alt="rawento"
                                    suppressHydrationWarning
                                />
                            </Link>
                        </div>
                        <div className={pulseCartCount ? 'mobile-pulse-active' : ''}>
                            <MobileHeaderActions />
                        </div>
                    </div>
                </header>
            )}
        </>
    );
};

export default HeaderMobileProduct;